import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpClient}from '@angular/common/http';
import { Csp5070Class } from '../../CSPClass/CSP5070/csp5070-class';
import { environment } from '../../../../../../../src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class Csp5070Service {
    baseUrl: string=  environment.baseUrlCsp + 'CSP5070/';
  constructor(private http:HttpClient) { }

    Transport(Csp5070Class:Csp5070Class):Observable<any>
             {               
                return this.http.post<any>(this.baseUrl+'Transport',Csp5070Class);
            }
  
}
